import {EventOption} from 'airbridge-web-sdk-loader/build/airbridge_api';
import {useAtomValue} from 'jotai';
import {mapAgentTypeAtom} from '@/map/atom';
import {IS_DEV_SERVER} from '@/router';
import {isMyfcEmailAccount, trackAirbridge, trackingGA} from '@/utils';
import {useSession} from './session';

export const useGA4WithParams = () => {
  const {user} = useSession();
  const mapAgent = useAtomValue(mapAgentTypeAtom);

  const tracking = (name: string, parameters?: Gtag.CustomParams) => {
    if (!parameters) {
      parameters = {};
    }

    // 모바일 지도 진입 시 세팅된 agent(myfc/lguplus)를 모든 이벤트에 자동으로 붙인다
    if (mapAgent) {
      parameters = {
        agent: mapAgent,
        ...parameters,
      };
    }

    if (user?.profile) {
      parameters = {
        ...parameters,
        ...user.profile,
      };
    }

    trackingGA(name, parameters);
  };

  return tracking;
};

export const useAirbridgeTracking = () => {
  const {user} = useSession();

  const tracking = (category: string, eventAttribute?: EventOption) => {
    if (!IS_DEV_SERVER && isMyfcEmailAccount(user?.email)) {
      console.log(
        '[Airbridge] 내부 회원 이벤트 트래킹 제외:',
        category,
        eventAttribute
      );
      return;
    }

    trackAirbridge(category, eventAttribute);
  };

  return tracking;
};
